const AUTH_RETURN_KEY = 'authReturnPath';

// if we are logged out while navigating to a route, save it to return after logging in
export function setReturnPath() {
  try {
    const { pathname, search, hash } = window.location;
    const nextLocation = `${pathname}${search}${hash}`;
    if (!pathname.startsWith('/login')) {
      sessionStorage[AUTH_RETURN_KEY] = nextLocation;
    }
  } catch {
    //disable eslint empty block error with this comment
  }
}

export function getReturnPath() {
  const returnPath = sessionStorage.getItem(AUTH_RETURN_KEY);
  return returnPath;
}

export function removeReturnPath() {
  sessionStorage.removeItem(AUTH_RETURN_KEY);
}
